module.exports = __webpack_public_path__ + "img/errors.a04beb8a.jpg";